// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react';
// @end dependencies

// @import components
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { AiOutlineLink } from 'react-icons/ai';
import { Link } from 'react-router-dom';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './CopyTextComponent.scss'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
// @end styles

interface ICopyTextComponentProps {
    text: string
    className?: string
    style?: CSSProperties
    id?: string
    linkToText?: boolean
    hideText?: boolean
}

const CopyTextComponent: React.FC<ICopyTextComponentProps> = (props) => {

    const [copied, updateCopied] = useState<boolean>(false);
    const screenNotification = new ScreenNotificationsUtil();

    useEffect(() => {
      if (copied) {
        screenNotification.fireToast({message: 'Enlace copiado', status: 'success'})
      }
    }, [copied])

    return(
        <div
            className={`copy_text_component-layout ${props.hideText ? '' : 'show-text'} ${props.className ? props.className : ''}`}
            style={props.style}
            id={props.id}
        >
          {!props.hideText ?
            <>
              {props.linkToText ?
                  <Link
                      to={{
                          pathname: props.text
                      }}
                      target='_blank'
                  >
                      <code>
                          {props.text}
                      </code>
                  </Link>
              :
                  <code>
                      {props.text}
                  </code>
              }
            </>
          :null}
          <CopyToClipboard
              onCopy={() => updateCopied(true)}
              text={props.text}
          >
              <AiOutlineLink
                  className={`${copied ? 'copied' : ''}`}
              />
          </CopyToClipboard>
        </div>
    );
}

export default CopyTextComponent;
